// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"873":"4ce0c60c","1745":"91b633bf","2548":"81269b00","4440":"5f3aeae7","6229":"6f097b31","8470":"cdd2302b","9405":"8aaceebf","9413":"deb2d796","9871":"3f7b804e"}[chunkId] + ".chunk.js";
};